import request from "config/api";
import {
  showAppApiAlert,
  startAppLoadAction,
  stopAppLoadAction,
} from "./appActions";

export const apiCallAction = ({
  requestMethod = "GET",
  requestUrl,
  requestData = {},
  requestHeaders = { "Content-Type": "application/json" },
  actionType,
  successType,
  errorType,
  successMessage = "Request successful.",
  defaultSuccessAction = false,
  errorMessage = "An error occurred.",
  extraParams = {}, // Optional extra params
  successCallback = () => {},
  errorCallback = () => {},
  params = {}, // Optional params for the request
}) => {
  return (dispatch) => {
    return new Promise((resolve) => {
      dispatch(startAppLoadAction());
      dispatch({
        type: actionType,
        payload: {
          loading: true,
          ...extraParams, // Additional params if needed
        },
      });

      request({
        method: requestMethod,
        url: requestUrl,
        body: requestData,
        headers: requestHeaders,
      })
        .then((response) => {
          if (defaultSuccessAction) {
            dispatch({
              type: successType,
              payload: {
                data: response.data,
                actionParams: params,
              },
            });
          }
          successCallback(response, dispatch);
          resolve(response.data);
          dispatch(stopAppLoadAction());
        })
        .catch((error) => {
          const apiErrorMessage =
            error?.response?.data?.message ||
            error?.response?.data ||
            errorMessage;
          dispatch({
            type: errorType,
            payload: {
              status: "error",
              text: errorMessage,
              loading: false,
            },
          });
          errorCallback(error, dispatch);
          dispatch(stopAppLoadAction());
          dispatch(
            showAppApiAlert({
              showAlert: true,
              type: "error",
              message: apiErrorMessage,
            })
          );
          resolve(null);
        });
    });
  };
};
